import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="hero" style={{ alignItems: 'center', justifyContent: 'center' }}>
      <div className="hero-content" style={{ textAlign: 'center' }}>
        <div className="notfound-code" aria-hidden="true">
          404
        </div>
        <h1 style={{ fontSize: 44 }}>Page not found</h1>
        <p className="page-hero-sub" style={{ marginBottom: 24 }}>
          The page you’re looking for doesn’t exist or has moved.
        </p>
        <Link to="/" className="btn-accent" style={{ textDecoration: 'none' }}>
          ← Back home
        </Link>
      </div>
    </section>
  );
}
